import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRouter } from './routing/app-router';
import { GlobalStyle } from './styles/theme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <AppRouter />
  </React.StrictMode>
);
